var React = require('react');

function RecordOn (props) {
    return React.createElement("svg",props,React.createElement("circle",{"cx":"12","cy":"12","r":"8","fill":"currentColor"}));
}

RecordOn.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = RecordOn;

RecordOn.default = RecordOn;
